<template>
  <div class="BookingHistory p-3">
    <v-card>
      <div class="pt-3">
        <v-btn class="mx-3" @click="filter_panel = !filter_panel">
          {{ $t("manage.by_school.group_experiment.history.btn_filter") }}
          <v-icon v-if="!filter_panel">mdi-menu-down</v-icon>
          <v-icon v-if="filter_panel">mdi-menu-up</v-icon>
        </v-btn>
        <v-btn class="mx-3" @click="applyFilter">
          <v-icon>mdi-reload</v-icon>
        </v-btn>
        <v-breadcrumbs :items="breadcrumbLabel('filter')" large></v-breadcrumbs>
      </div>
      <v-expand-transition>
        <div class="mx-3 mb-5"  v-show="filter_panel">
          <v-card>
            <v-row class="justify-center p-3">
              <v-col cols="12">
                <v-select
                  :items="api.schools"
                  item-text="school_id"
                  item-value="school_id"
                  v-model="form.school_id"
                  :label="filterLabel('school_label')"
                  dense
                  :disabled="current.user_level!='ADMIN'"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="api.experiments"
                  :item-text="filterLabel('experiment_set_text')"
                  item-value="experiment_set"
                  v-model="form.selected_experiment"
                  :label="filterLabel('experiment_set_label')"
                  no-data-text="No Experiment Available"
                  dense
                  @change="changeExperimentSet(form.selected_experiment)"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-if="$i18n.locale=='tc'"
                  :items="statuses"
                  item-text="text_chi"
                  item-value="text"
                  v-model="form.status"
                  :label="filterLabel('status_label')"
                  dense
                  :disabled="current.user_level!='ADMIN'"
                ></v-select>
                <v-select
                  v-else
                  :items="statuses"
                  item-text="text"
                  item-value="text"
                  v-model="form.status"
                  :label="filterLabel('status_label')"
                  dense
                  :disabled="current.user_level!='ADMIN'"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  range
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      :label="filterLabel('date_range_label')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="form.dates=[]"
                      dense
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :locale="localeTranslate()"
                    v-model="form.dates"
                    color="green lighten-2"
                    range
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="green " @click="menu = false">
                      {{ $t("manage.by_school.group_experiment.history.filter.btn_datepicker_close") }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-btn
                  class="mr-2"
                  color="primary"
                  @click="applyFilter"
                >
                  {{ $t("manage.by_school.group_experiment.history.filter.btn_apply") }}
                </v-btn>
                <v-btn
                  color="grey lighten-3"
                  @click="resetFilter"
                >
                  {{ $t("manage.by_school.group_experiment.history.filter.btn_reset") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-expand-transition>
      <v-data-table
        dense
        :locale="localeTranslate()"
        :headers="bookSlotLabel('header')"
        :items="api.group_experiment_slots"
        item-key="id"
        :sort-by="['start_date']"
        :sort-desc="[true]"
        multi-sort
        :items-per-page="5"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top color="blue darken-4">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="viewGroupExperimentSlot(item)">
                <v-icon small color="blue darken-4"> mdi-magnify </v-icon>
              </v-btn>
            </template>
            <span class="text-center">{{ $t("manage.by_school.group_experiment.history.btn_view") }}<small><br>{{ $t("manage.by_school.group_experiment.history.view_group_hint_1") }}<br>{{ $t("manage.by_school.group_experiment.history.view_group_hint_2") }}</small></span>
          </v-tooltip>

          <v-tooltip top color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn disabled icon v-bind="attrs" v-on="on" @click="openUserGroupDialog(item)">
                <v-icon small color="teal"> mdi-account-plus </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.group_experiment.history.btn_assign_group") }}</span>
          </v-tooltip>
          <v-tooltip v-if='item.status!="CANCELLED"' top color="red lighten-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn  icon v-bind="attrs" v-on="on" @click="openCancelGroupExperimentDialog(item)">
                <v-icon small color="red lighten-2"> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.group_experiment.history.btn_remove") }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-card v-if="slot_view" class="my-3 mb-8">
      <h6 class="p-3 pb-0">{{ $t("manage.by_school.group_experiment.history.view_period.header") }}</h6>
      <v-breadcrumbs :items="breadcrumbLabel('booking')" large></v-breadcrumbs>
      <v-row>
        <v-col sm="12" md="4" class="mx-4">
          <v-card>
            <v-card-title class="body-1">
              <u><v-icon class="pr-2">mdi-information</v-icon>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.header") }}</u>
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                <div class="text-body-2 mt-n4">
                  <v-card-text class="pt-0 text-body-1 font-weight-bold">
                    <div class="text-body-2 px-auto">
                      <table style="border-collapse: collapse;">
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.ref") }}</td>
                          <td class="pl-2">{{ selected_slot.ref }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.experiment_set") }}</td>
                          <td v-if="$i18n.locale=='tc'" class="pl-2">{{ api.group_experiment_info.experiment_set_chi }}</td>
                          <td v-else class="pl-2">{{ api.group_experiment_info.experiment_set }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.start") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.start_datetime }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.end") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.end_datetime }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.actual_end") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.actual_end_time }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.status") }}</td>
                          <td v-if="$i18n.locale=='tc'" class="pl-2">{{ api.group_experiment_info.status_chi }}</td>
                          <td v-else class="pl-2">{{ api.group_experiment_info.status }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.create_by") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.create_by }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.create_at") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.create_at }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.last_update") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.update_at }}</td>
                        </tr>
                      </table>
                    </div>
                  </v-card-text>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="12" md="4" class="mx-4">
          <v-card>
            <v-card-title class="body-1">
              <u><v-icon class="pr-2">mdi-cog</v-icon>{{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.header") }}</u>
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                <div v-if="api.group_experiment_info.config_exist==true" class="text-body-2 mt-n4">
                  <v-card-text class="pt-0 text-body-1 font-weight-bold">
                    <div class="text-body-2 px-auto">
                      <table style="border-collapse: collapse;">
                        <tr v-for="(value, key) in api.group_experiment_info.config" :key="key" style="border-bottom: 1px solid lightgray;">
                          <td>{{ key }}:</td>
                          <td class="pl-2">{{ value }}</td>
                        </tr>
                      </table>
                    </div>
                  </v-card-text>
                </div>
                <div v-else>
                  {{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.no_record") }}
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="openEditConfigDialog()">{{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.btn_edit") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>        
        <v-col v-if="0" sm="12" md="3" class="mx-4">
          <v-card>
            <v-card-title class="body-1">
              <u><v-icon class="pr-2">mdi-image-multiple</v-icon>{{ $t("manage.by_school.group_experiment.history.view_period.snapshot.header") }}</u>
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                <div v-if="api.group_experiment_info.photo_exist==true" class="text-body-2 mt-n4">
                  <v-card-text class="pt-0 text-body-1 font-weight-bold">
                    <div class="text-body-2 px-auto">
                      <div v-for="(item, i) in api.group_experiment_info.photos" :key="i">
                          <a :href="item.src" target="_BLANK"><v-icon class="p-1" color="primary" small>mdi-image-outline</v-icon>{{ item.filename }}</a>
                        </div>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="downloadGroupExperimentSnapshots()">{{ $t("manage.by_school.group_experiment.history.view_period.snapshot.btn_download_all") }}</v-btn>
                  </v-card-actions>
                </div>
                <div v-else>
                  {{ $t("manage.by_school.group_experiment.history.view_period.snapshot.no_snapshot") }}
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog
      v-model="userGroupDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("manage.by_school.group_experiment.history.assign_group.header") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ userGroupItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ userGroupItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ userGroupItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ userGroupItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.date") }}</th>
              <td>{{ userGroupItem.start_date }} - {{ userGroupItem.end_date }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.open_hour") }}</th>
              <td>{{ userGroupItem.open_time }} - {{ userGroupItem.close_time }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.user_group") }}</th>
              <td>{{ userGroupItem.groups }}</td>
            </tr>
          </table>
          <hr>
          <v-checkbox
                v-model="assignCheckbox"
                hide-details
                class="shrink mr-2 mt-0"
              ></v-checkbox>
              <v-select
                multiple
                chips
                :items="assignedGroups"
                item-text="user_group"
                item-value="user_group"
                v-model="editGroups"
                :label="assignGroupLabel('assign')"
                :disabled="!assignCheckbox"
              ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeUserGroupDialog()"
          >
            Discard
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="assignGroupsToBookSlot(userGroupItem)"
            :disabled="!assignCheckbox"
          >
            Set
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="cancelGroupExperimentDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("manage.by_school.group_experiment.history.cancel_slot.header") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.group_experiment.history.cancel_slot.ref") }}</th>
              <td>{{ cancelGroupExperimentItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.group_experiment.history.cancel_slot.school") }}</th>
              <td>{{ cancelGroupExperimentItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.group_experiment.history.cancel_slot.experiment") }}</th>
              <td>{{ cancelGroupExperimentItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.group_experiment.history.cancel_slot.equipment_id") }}</th>
              <td>{{ cancelGroupExperimentItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.group_experiment.history.cancel_slot.start_time") }}</th>
              <td>{{ cancelGroupExperimentItem.start_datetime }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.group_experiment.history.cancel_slot.end_time") }}</th>
              <td>{{ cancelGroupExperimentItem.end_datetime }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="cancelGroupExperimentDialog = false; cancelGroupExperimentItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            text
            @click="cancelGroupExperiment(cancelGroupExperimentItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="lockBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_lock") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ lockUnlockBookingItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ lockUnlockBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ lockUnlockBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ lockUnlockBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ lockUnlockBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ lockUnlockBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="lockBookingDialog = false; lockUnlockBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            text
            @click="lockBooking(lockUnlockBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="unlockBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_unlock") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ lockUnlockBookingItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ lockUnlockBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ lockUnlockBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ lockUnlockBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ lockUnlockBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ lockUnlockBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="unlockBookingDialog = false; lockUnlockBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="unlockBooking(lockUnlockBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="maintenanceDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_set_maintenance") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ maintenanceItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ maintenanceItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ maintenanceItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ maintenanceItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ maintenanceItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ maintenanceItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="maintenanceDialog = false; maintenanceItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            text
            @click="setMaintenanceBooking(maintenanceItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="unsetMaintenanceDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_unset_maintenance") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ maintenanceItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ maintenanceItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ maintenanceItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ maintenanceItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ maintenanceItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ maintenanceItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="unsetMaintenanceDialog = false; maintenanceItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="unsetMaintenanceBooking(maintenanceItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>    
    <v-dialog
      v-model="cancelBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_remove") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ cancelBookingItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ cancelBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ cancelBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ cancelBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ cancelBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ cancelBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="cancelBookingDialog = false; cancelBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            text
            @click="cancelBooking(cancelBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="undoCancelBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_restore") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ cancelBookingItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ cancelBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ cancelBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ cancelBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ cancelBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ cancelBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="undoCancelBookingDialog = false; cancelBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="undoCancelBooking(cancelBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog
      v-model="editConfigDialog"
      persistent
      max-width="650"
    >
      <v-card class="pb-3">
        <v-card-title class="text-h5">
          {{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.header") }}
        </v-card-title>
        <v-card-text class="pb-0">
          <table style="border-collapse: collapse;">
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.ref") }}</th>
              <td>{{ api.group_experiment_info.ref }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.school") }}</th>
              <td>{{ api.group_experiment_info.school }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ api.group_experiment_info.experiment_set }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.start") }}</th>
              <td>{{ api.group_experiment_info.start_datetime }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.end") }}</th>
              <td>{{ api.group_experiment_info.end_datetime }}</td>
            </tr>            
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.actual_end") }}</th>
              <td>{{ api.group_experiment_info.actual_end_time }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.recent_display") }}</th>
              <td>{{ api.group_experiment_info.config }}</td>
            </tr>
          </table>
          <v-row v-if="0" class="mt-3">
            <v-textarea
              filled
              :label="editSettingLabel('textarea')"
              v-model="editConfigForm.value"
            ></v-textarea>
          </v-row>
        </v-card-text>
        <v-container>
              <v-divider class=""></v-divider>
              <h6>{{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.sub_header") }}</h6>
          <v-form ref="editForm" v-model="isValidEdit" lazy-validation>
            <v-row
              v-for="(pair, idx) in configPairs"
              :key="idx"
              class="mb-2"
              align="center"
            >
              <v-col class="pb-3" cols="12" sm="12">
                </v-col>
              <!-- Key -->
              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model="pair.key"
                  :label="editSettingLabel('item')"
                  :placeholder="placeholderLabel('item', pair)"
                  outlined
                  dense
                  clearable
                  :rules="[rules.required('Key', idx), rules.keyUnique(idx)]"
                  @input="onFieldInput(idx)"
                  @click:clear="onClearKey(idx)"
                />
              </v-col>
              <!-- Value -->
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field
                  v-model="pair.value"
                  :label="editSettingLabel('content')"
                  :placeholder="placeholderLabel('content', pair)"
                  outlined
                  dense
                  clearable
                  :rules="[rules.required('Value', idx)]"
                  @input="onFieldInput(idx)"
                  @click:clear="onClearValue(idx)"
                />
              </v-col>
              <v-col class="pt-0 text-left" cols="12" sm="2">
                <v-tooltip top color="error">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      color="red"
                      @click="removePair(idx)"
                      :disabled="configPairs.length === 1"
                      :title="configPairs.length === 1 ? 'Keep at least one row' : 'Delete row'"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.btn_delete_item") }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <div class="mb-3">
              <v-btn color="primary" class="mr-3" @click="addPair">
                <v-icon left>mdi-plus</v-icon>{{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.btn_add_item") }}
              </v-btn>
            </div>
          </v-form>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="api.group_experiment_info.config_exist!=false" text color="error" @click="removeGroupExperimentConfig()">
            {{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.btn_remove") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="closeEditConfigDialog">
            {{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.btn_discard") }}
          </v-btn>
          <v-btn color="green darken-1" text @click="editGroupExperimentConfig()">
            {{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.btn_save_changes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  
import {api_general} from '@/services/iot/api_general';
const apiGeneral = new api_general(process.env.VUE_APP_BASE_URL);

import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);


import { api_experiment } from "@/services/iot/api_experiment";
const apiExperiment = new api_experiment(process.env.VUE_APP_BASE_URL);


export default {
  name: "GroupExperimentHistory",
  data: function () {
    return {
      configPairs: [],
      requiredRule: v => (v !== null && v !== undefined && String(v).trim() !== '') || 'Required',
      isValidEdit: false,
      
      placeholderList :[
        { key: 'eg: Start record at', value: 'eg: 2025-01-15 10:15am' },
        { key: 'eg: Stop record at', value: 'eg: 2025-01-17 10:15am' },
        { key: 'eg: Light color', value: 'eg: Red' },
        { key: 'eg: Setup location', value: 'eg: Biology Lab' }
      ],
      placeholderListChi :[
        { key: '例如：開始記錄於', value: '例如：2026-01-17 早上10:15' },
        { key: '例如：結束記錄於', value: '例如：2026-01-17 下午5:30' },
        { key: '例如：燈光顏色', value: '例如：紅色' },
        { key: '例如：裝置位置', value: '例如：生物實驗室' }
      ],

      menu: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      api: {
        schools: [],
        experiment_sets: [],
        experiments: [],
        group_experiment_slots: [],
        group_experiment_info: [],
        bookings: [],
        status: "ACTIVE",
      },
      form: {
        selected_experiment: "All",
        start_from: "09:00",
        end_at: "18:00",
        duration: "55",
        prepare: "5",
        status: "ACTIVE",
        school_id: "",
        dates: [],
        experiment: "All",
        equipment_id: "All",
      },
      editConfigForm: {
        value: "",
      },
      viewItem: "",
      assignCheckbox: false,
      userGroupItem: {},
      assignedGroups: [],
      editGroups: [],
      lockUnlockItem: {},
      lockUnlockBookingItem: {},
      maintenanceItem: {},
      cancelGroupExperimentItem: {},
      cancelBookingItem: {},      
      holdCheckbox:true,
      dialog: false,
      editConfigDialog: false,
      userGroupDialog: false,
      unlockDialog: false,
      lockDialog:false,
      lockBookingDialog: false,
      unlockBookingDialog: false,
      maintenanceDialog: false,
      unsetMaintenanceDialog:false,
      cancelGroupExperimentDialog: false,
      cancelBookingDialog: false,
      undoCancelBookingDialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      school_id: "",
      experiment: "",
      equipment_id: "",
      school_valid: false,
      role: null,
      drawer: true,
      mini: true,
      slot_view: false,
      booking_breadcrumbs: [],
      booking_breadcrumbs_chi: [],
      filter_breadcrumbs: [{ text: 'Filter'},],
      filter_breadcrumbs_chi: [{ text: '篩選'},],
      filter_panel: false,
      selected_slot: null,
      statuses: [
        { text: "ACTIVE", text_chi: "有效", value: "ACTIVE" },
        { text: "CANCELLED", text_chi: "已移除", value: "CANCELLED" },
        { text: "HOLD", text_chi: "暫停", value: "HOLD" },
      ],
      headers: [
        { text: "Ref", value: "ref" },
        { text: "School", value: "school" },
        { text: "Experiment Set", value: "experiment_set" },
        { text: "Start Date/time", value: "start_datetime" },
        { text: "End Date/time", value: "end_datetime" },
        { text: "Actual End", value: "actual_end_time" },
        { text: "Groups", value: "groups" },
        { text: "Status", value: "status" },
        { text: "Create by", value: "create_by" },
        { text: "Create at", value: "create_at" },
        { text: "Update at", value: "update_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      headers_chi: [
        { text: "參考編號", value: "ref" },
        { text: "學校ID", value: "school" },
        { text: "實驗組", value: "experiment_set_chi" },
        { text: "開始日期/時間", value: "start_datetime" },
        { text: "結束日期/時間", value: "end_datetime" },
        { text: "實際結束日期/時間", value: "actual_end_time" },
        { text: "用戶組別", value: "groups" },
        { text: "狀態", value: "status_chi" },
        { text: "創建者", value: "create_by" },
        { text: "創建於", value: "create_at" },
        { text: "最後更新", value: "update_at" },
        { text: "操作", value: "actions", sortable: false },
      ],
      booking_headers: [
        { text: "Session Start", value: "start_at" },
        { text: "Session End", value: "end_at" },
        { text: "Status", value: "status" },
        { text: "Has Entered", value: "has_entered" },
        { text: "Username", value: "username" },
        { text: "Update at", value: "update_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      booking_headers_chi: [
        { text: "時段開始", value: "start_at" },
        { text: "時段結束", value: "end_at" },
        { text: "狀態", value: "status_chi" },
        { text: "已進入", value: "has_entered" },
        { text: "用戶名稱", value: "username" },
        { text: "最後更新", value: "update_at" },
        { text: "操作", value: "actions", sortable: false },
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
//    if(self.current.user_level != "ADMIN" ){
      self.api.schools = [self.current.school_id];
      self.form.school_id = self.current.school_id;
//    }
    self.filter_breadcrumbs = [
      { text: 'School: ' + self.current.school_id },
      { text: 'Experiment Set: All' },
      { text: 'Status: ACTIVE' },
      { text: 'Date: All' }
    ];
    self.filter_breadcrumbs_chi = [
      { text: '學校: ' + self.current.school_id },
      { text: '實驗組: 全部' },
      { text: '狀態: 有效' },
      { text: '日期: 全部' }
    ];
    self.getSchoolFromSchoolList();
    self.getSchoolGroupExperiment();
    self.getSchoolUserGroups();
    apiManagement
    .getGroupExperimentSlotsBySchool(self.current.school_id, 'All', 'All', null, null, self.form.status)
    .then((response) => {
      self.api.group_experiment_slots = response.group_experiment_slots;
    });
  },  
  computed: {
    dateRangeText() {
      return this.form.dates.join(" ~ ");
    },
    // Validation rules that depend on row index and current array content
   
rules() {
    return {
      required: (fieldName, idx) => (v) => {
        const row = this.configPairs[idx];
        if (!row.touched) return true; // skip validation if untouched
        const val = ((v || '') + '').trim();
        return val.length > 0 || fieldName + ' is required';
      },
      keyUnique: (idx) => (v) => {
        const row = this.configPairs[idx];
        if (!row.touched) return true; // skip validation if untouched
        const k = ((v || '') + '').trim().toLowerCase();
        if (!k) return true;
        const dup = this.configPairs.some((p, i) =>
          i !== idx && ((p.key || '') + '').trim().toLowerCase() === k
        );
        return dup ? 'Duplicate key' : true;
      },
    };
  },



    
  },
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    getSchoolGroupExperiment() {
      var self = this;
      apiManagement.getSchoolGroupExperiment(self.current.school_id).then((response) => {
        self.api.experiments = [{'experiment_set':'All', 'experiment_set_chi':'全部'}]
        self.api.experiments = self.api.experiments.concat(response.experiments);
      });
    },
    getSchoolFromSchoolList() {
      var self = this;
      apiManagement.getSchoolFromSchoolList(self.current.school_id).then((response) => {
        if (response.status == "success") {
          self.school_valid = true;
        } else {
          self.school_valid = false;
          alert(response.error);
        }
      });
    },
    changeExperimentSet(experiment_set){      
      var self = this;
      if(experiment_set=="All"){
        experiment_set = "All - All";
      }
      let split = experiment_set.split(" - ");
      self.form.experiment = split[0];
      self.form.equipment_id = split[1];
    },
    editSettingLabel(label){
      var self = this;
      if(label == 'textarea') return self.$t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.text_note");
      if(label == 'item') return self.$t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.item");
      if(label == 'content') return self.$t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.content");
    },
    placeholderLabel(label, pair){
      var self = this;
      if(self.$i18n.locale=='tc') {
        if(label == 'item') return pair.placeholderKeyChi;
        if(label == 'content') return pair.placeholderValueChi;
      }
      else {
        if(label == 'item') return pair.placeholderKey;
        if(label == 'content') return pair.placeholderValue;
      }
    },
    lockBookSlotLabel(label){
      var self = this;
      if(label == 'suspendCheckbox') return self.$t("booking.dialog.book_slot.suspend_checkbox");
    },
    assignGroupLabel(label){
      var self = this;
      if(label == 'assign') return self.$t("manage.by_school.group_experiment.history.assign_group.assign_group");
    },
    bookSlotLabel(label) {
      var self = this;
      if(label=='header') {
        if(self.$i18n.locale=='tc') return self.headers_chi;
        else return self.headers;
      }
      else if(label=='experiment_set_label') return self.$t("manage.by_school.group_experiment.history.filter.experiment_set");
      else if(label=='experiment_set_text') {
        if(self.$i18n.locale=='tc') return 'experiment_set_chi';
        else return 'experiment_set';
      }
    },
    bookingLabel(label) {
      var self = this;
      if(label=='header') {
        if(self.$i18n.locale=='tc') return self.booking_headers_chi;
        else return self.booking_headers;
      }
      else if(label=='experiment_set_label') return self.$t("manage.by_school.group_experiment.history.filter.experiment_set");
      else if(label=='experiment_set_text') {
        if(self.$i18n.locale=='tc') return 'experiment_set_chi';
        else return 'experiment_set';
      }
    },
    breadcrumbLabel(label){
      var self = this;
      if(label=='filter') {
        if(self.$i18n.locale=='tc') return self.filter_breadcrumbs_chi;
        else return self.filter_breadcrumbs;
      }
      else if(label=='booking') {
        if(self.$i18n.locale=='tc') return self.booking_breadcrumbs_chi;
        else return self.booking_breadcrumbs;
      }
    },
    filterLabel(label){
      var self = this;
      if(label=='school_label') return self.$t("manage.by_school.group_experiment.school");
      else if(label=='experiment_set_label') return self.$t("manage.by_school.group_experiment.history.filter.experiment_set");
      else if(label=='experiment_set_text') {
        if(self.$i18n.locale=='tc') return 'experiment_set_chi';
        else return 'experiment_set';
      }
      else if(label=='date_range_label') return self.$t("manage.by_school.group_experiment.history.filter.date_range");
      else if(label=='status_label') return self.$t("manage.by_school.group_experiment.history.filter.status");
    },
    applyFilter(){
      var self = this;
      if(self.isValid()){
        apiManagement
          .getGroupExperimentSlotsBySchool(self.form.school_id, self.form.experiment, self.form.equipment_id, self.form.dates[0], self.form.dates[1], self.form.status)
          .then((response) => {
            self.api.group_experiment_slots = response.group_experiment_slots;
            let s_date = "All";
            if(self.form.dates[0]!=undefined && self.form.dates[1]!=undefined) {
              s_date = self.form.dates[0] + " ~ " + self.form.dates[1];
            }
            self.filter_breadcrumbs = [
              { text: 'School: ' + self.current.school_id },
              { text: 'Experiment: ' + self.form.selected_experiment },
              { text: 'Status: ' + self.form.status },
              { text: 'Date: ' + s_date }
            ];
            self.filter_panel = false;
            self.slot_view = false;
          });
      }
    },
    resetFilter(){
      var self = this;
      self.form.experiment = "All";
      self.form.equipment_id = "All";
      self.form.dates = [];
      self.form.selected_experiment = "All";
      apiManagement
        .getGroupExperimentSlotsBySchool(self.form.school_id, self.form.experiment, self.form.equipment_id, self.form.dates[0], self.form.dates[1], self.form.status)
        .then((response) => {
          self.api.group_experiment_slots = response.group_experiment_slots;
          self.filter_breadcrumbs = [
            { text: 'School: ' + self.current.school_id },
            { text: 'Experiment: All' },
            { text: 'Date: All' }
          ];
          self.filter_breadcrumbs_chi = [
            { text: '學校: ' + self.current.school_id },
            { text: '實驗組: 全部' },
            { text: '日期: 全部' }
          ];
          self.filter_panel = false;
        });
    },
    viewGroupExperimentSlot(item) {
      var self = this;
      self.viewItem = item;
      apiManagement
        .getGroupExperimentSlotInfo(self.form.school_id, item.ref)
        .then((response) => {
          self.api.group_experiment_info = response.group_experiment_info;
          self.slot_view = true;
          self.booking_breadcrumbs = [
            { text: 'School: ' + item.school },
            { text: 'Experiment Set: ' + item.experiment + ' - ' + item.equipment_id},
            { text: "Ref: " + item.ref },
          ];
          self.booking_breadcrumbs_chi = [
            { text: '學校: ' + item.school },
            { text: '實驗組: ' + item.experiment_chi + ' - ' + item.equipment_id_chi },
            { text: "參考編號: " + item.ref },
          ];
          self.selected_slot = item;
        });
    },
    assignGroupsToBookSlot(item){
      var self = this;
      
      apiManagement.assignGroupsToBookSlot(item.school,self.editGroups,item.ref)
      .then((response) => {
        if(response.status == "success"){          
          self.applyFilter();
          self.$store.commit("showSnackBar", "Updated user groups to booking ref: " + item.ref);
          self.closeUserGroupDialog();
          //self.getSchoolBookSlots();
        }
        else {
          alert(response.message);
        }
      });
    },
    lockBookSlot(item, hold) {
      var self = this;
      apiManagement
        .lockBookSlot(self.current.school_id, item.ref, self.holdCheckbox)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.form.school_id, self.form.experiment, self.form.equipment_id, self.form.dates[0], self.form.dates[1], self.form.status
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, item.ref)
            .then((response) => {
              self.lockUnlockItem = {};
              self.lockDialog = false;
              self.holdCheckbox = true;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: item.school },
                { text: item.experiment },
                { text: item.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: item.school },
                { text: item.experiment_chi },
                { text: item.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    unlockBookSlot(item) {
      var self = this;
      apiManagement
        .unlockBookSlot(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, item.ref)
            .then((response) => {
              self.lockUnlockItem = {};
              self.unlockDialog = false;
              self.holdCheckbox = true;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: item.school },
                { text: item.experiment },
                { text: item.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: item.school },
                { text: item.experiment_chi },
                { text: item.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    lockBooking(item) {
      var self = this;
      apiManagement
        .lockBooking(self.current.school_id, item.ref, item.status)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.lockBookingDialog = false;
              self.lockUnlockBookingItem= {}
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    unlockBooking(item) {
      var self = this;
      apiManagement
        .unlockBooking(self.current.school_id, item.ref, item.status)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.unlockBookingDialog = false;
              self.lockUnlockBookingItem= {}
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    setMaintenanceBooking(item) {
      var self = this;
      apiManagement
        .setMaintenanceBooking(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.maintenanceItem = {};
              self.maintenanceDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + self.selected_slot.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + self.selected_slot.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    unsetMaintenanceBooking(item) {
      var self = this;
      apiManagement
        .unsetMaintenanceBooking(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.maintenanceItem = {};
              self.unsetMaintenanceDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    cancelGroupExperiment(item) {
      var self = this;
      apiManagement
        .cancelGroupExperiment(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            apiManagement
              .getGroupExperimentSlotsBySchool(self.form.school_id, self.form.experiment, self.form.equipment_id, self.form.dates[0], self.form.dates[1], self.form.status)
              .then((response) => {
                self.api.group_experiment_slots = response.group_experiment_slots;
                let s_date = "All";
                if(self.form.dates[0]!=undefined && self.form.dates[1]!=undefined) {
                  s_date = self.form.dates[0] + " ~ " + self.form.dates[1];
                }
                self.filter_breadcrumbs = [
                  { text: 'School: ' + self.current.school_id },
                  { text: 'Experiment: ' + self.form.selected_experiment },
                  { text: 'Status: ' + self.form.status },
                  { text: 'Date: ' + s_date }
                ];
                self.filter_panel = false;
                self.slot_view = false;
                self.cancelGroupExperimentDialog = false;
                self.cancelGroupExperimentItem = {};
              });

          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    cancelBooking(item) {
      var self = this;
      apiManagement
        .cancelBooking(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.cancelBookingItem = {};
              self.cancelBookingDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + self.selected_slot.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + self.selected_slot.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    undoCancelBooking(item) {
      var self = this;
      apiManagement
        .undoCancelBooking(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.cancelBookingItem = {};
              self.undoCancelBookingDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + self.selected_slot.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + self.selected_slot.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    createBookSlots: function () {
      var self = this;     
//      if (self.isValid()) {
      apiService.createBookSlots(
          self.form.school,
          self.form.experiment,
          self.form.equipment_id,
          self.form.dates[0],
          self.form.dates[1],
          self.form.start_from,
          self.form.end_at,
          self.form.duration,
          self.form.prepare
        )
        .then((response) => {
          if (response.status == "success") {
            alert("success");
//            alert("Assigned " + response.count + " slots successfully");
          } else {
            alert(response.message);
          }
        });
//      }
    },
    isValid: function () {
      var self = this;
      if (self.form.dates[0] != undefined && self.form.dates[1] == undefined) {
        alert("Missing end date");
        return false;
      }
      if (self.form.dates[0] > self.form.dates[1]) {
        alert("End date should be larger than Start date");
        return false;
      }
      return true;
    },
    back() {
      var self = this;
      self.$router.push("/school/experiment_list/" + self.current.school_id);
    },
    getSchoolUserGroups(){
      var self = this;
      apiManagement.getSchoolUserGroups(self.current.school_id)
      .then((response) => {
          self.api.groups = response.groups;
      });
    },
    openUserGroupDialog(item){
      var self = this;
      self.userGroupDialog = true;
      self.userGroupItem = item;
      self.assignedGroups = self.api.groups;
      if(item.groups==""){
        self.editGroups = [];
      }
      else {
        self.editGroups = item.groups.split(", ");
      }
    },
    closeUserGroupDialog(){
      var self = this;
      self.userGroupDialog = false;
      self.userGroupItem = {};
      self.assignCheckbox = false;
      self.editGroups = [];
    },
    openCancelGroupExperimentDialog(item){
      var self = this;
      self.cancelGroupExperimentDialog = true;
      self.cancelGroupExperimentItem = item;
    },
    openCancelBookingDialog(item){
      var self = this;
      self.cancelBookingDialog = true;
      self.cancelBookingItem = item;
    },
    openUndoCancelBookingDialog(item){
      var self = this;
      self.undoCancelBookingDialog = true;
      self.cancelBookingItem = item;
    },



  addPair() {
    var self = this;
    let randomIndex = Math.floor(Math.random() * self.placeholderList.length);
    let randomPair = self.placeholderList[randomIndex];
    let randomPairChi = self.placeholderListChi[randomIndex];
    self.configPairs.push({
      key: '',
      value: '',
      touched: false,
      placeholderKey: randomPair.key,
      placeholderValue: randomPair.value,
      placeholderKeyChi: randomPairChi.key,
      placeholderValueChi: randomPairChi.value
    });
  },
  onFieldInput(idx) {
    this.configPairs[idx].touched = true; // mark row as touched
    this.$refs.form && this.$refs.form.validate();
  },
  removePair(index) {
    if (this.configPairs.length === 1) return;
    this.configPairs.splice(index, 1);
    this.$nextTick(() => this.$refs.form && this.$refs.form.validate());
  },
  onClearKey(idx) {
    // Clear the key field for the given row
    this.configPairs[idx].key = '';
    // Optional: mark row as touched so validation updates
    this.configPairs[idx].touched = true;
    // Re-run validation if needed
    this.$nextTick(() => this.$refs.form && this.$refs.form.validate());
  },
  onClearValue(idx) {
    // Clear the value field for the given row
    this.configPairs[idx].value = '';
    this.configPairs[idx].touched = true;
    this.$nextTick(() => this.$refs.form && this.$refs.form.validate());
  },
  editGroupExperimentConfig() {
    var self = this;      
// 1. Validate all fields
// 2. If not valid, show alert and stop
    if (!this.$refs.editForm.validate()) {
      alert('Please fill in all required fields correctly before saving.');
      return;
    }
// 3. Build JSON object from configPairs
    let json_array = {};
    this.configPairs.forEach(({ key, value }) => {
      let k = (key || '').trim();
      let v = (value || '').trim();
      if (k) {
        json_array[k] = v; // include only rows with a key
      }
    });
// 4. You can now send json_array to your server
    json_array = JSON.stringify(json_array);
    apiManagement.editGroupExperimentConfig(self.api.group_experiment_info.school, self.api.group_experiment_info.experiment, self.api.group_experiment_info.equipment_id, self.api.group_experiment_info.ref, json_array)
      .then((response) => {
        if (response.status == "success") {
          alert("success");
          self.closeEditConfigDialog();
          self.viewGroupExperimentSlot(self.viewItem);
        } else {
          alert(response.message);
        }
      });
  },
  removeGroupExperimentConfig() {
    var self = this;
    apiManagement.editGroupExperimentConfig(self.api.group_experiment_info.school, self.api.group_experiment_info.experiment, self.api.group_experiment_info.equipment_id, self.api.group_experiment_info.ref)
      .then((response) => {
        if (response.status == "success") {
          alert("success");
          self.closeEditConfigDialog();
          self.viewGroupExperimentSlot(self.viewItem);
        } else {
          alert(response.message);
        }
      });
    },
    openEditConfigDialog(){
      var self = this;
      self.editConfigDialog = true;
      if(self.api.group_experiment_info.config_exist){
        self.editConfigForm.value = JSON.stringify(self.api.group_experiment_info.config);
        const cfg = this.api.group_experiment_info.config || {};
        const entries = Object.entries(cfg);
        let randomIndex = Math.floor(Math.random() * self.placeholderList.length);
        let randomPair = self.placeholderList[randomIndex];
        let randomPairChi = self.placeholderListChi[randomIndex];
        this.configPairs = entries.length
          ? entries.map(([key, value]) => ({ key, value, touched: true, placeholderKey: randomPair.key, placeholderValue: randomPair.value, placeholderKeyChi: randomPairChi.key, placeholderValueChi: randomPairChi.value })) // existing rows are touched
          : [{ key: '', value: '', touched: false }]; // new row starts untouched
      }
      else {
      }
    },
    closeEditConfigDialog(){
      var self = this;
      self.editConfigDialog = false;
      self.editConfigForm.value = "";
      
      self.configPairs = [];
    },
    downloadGroupExperimentSnapshots(){
      var self = this;
      
      apiExperiment.downloadGroupExperimentSnapshots(self.viewItem.school, self.viewItem.experiment, self.viewItem.equipment_id, self.viewItem.ref)
        .then((response) => {
          if(response.status == "success"){
            window.open(process.env.VUE_APP_BASE_URL + "/api/iot/experiment/storage/" + response.downloadPath);
          }
          else {
            alert(response.message);
          }
        });
    }
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>